/**
 * Created by LIDHCRT on 2/16/2018.
 */
module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http",
                      function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider) {

                          new Service({
                                          name: 'censusReport',
                                          group:"eprsvc",
                                          url:"/eprsvc/x-services/secure/reports/v1",
                                          headers: {},
                                          runCensusReport: function(params) {


                                              if(params.reportName && params.reportName !== undefined){
                                                  this.url += "/wellness/request-report"
                                              }
                                              else {
                                                  this.url += "/census/request-report";
                                              }
                                              if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                                                  this.headers['ClientNumber']  = sessionData.clientNumber;
                                              }
                                              this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                              return this.post({ payload: params });
                                          },
                                          fetchRequestedReports: function(reportType) {

                                              if(reportType === 'wellness'){
                                                  this.url += "/wellness";
                                              }else {
                                                  this.url += "/census";
                                              }
                                              if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                                                  this.headers['ClientNumber']  = sessionData.clientNumber;
                                              }
                                              this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                              this.flushCache();
                                              return this.get();
                                          }
                                      });
                      }]);
};